import {
	Checkbox,
	Col,
	Form,
	Input,
	Row,
	Typography,
	notification,
	Flex,
} from "antd";
import React, { useEffect, useState } from "react";
import { api } from "../utils/Api";
import axios from "axios";
import { CustomSpinner } from "../utils/CustomComponents";
const { Text } = Typography;

const ProductionMonthlyView = ({ productionId }) => {
	const [form] = Form.useForm();
	const [loadingButton, setLoadingButton] = useState(true);
	const [initialValues, setInitialValues] = useState({});
	const [apiNotification, contextHolder] = notification.useNotification();

	const openNotification = (type, message, description) => {
		apiNotification[type]({
			message: message,
			description: description,
		});
	};

	useEffect(() => {
		getProduction();
	}, []);

	const getProduction = async () => {
		try {
			setLoadingButton(true);

			const url = api + `/production-new/eticket/${productionId}`;
			const token = localStorage.getItem("token");
			axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

			const { data } = await axios.get(url);
			if (data.success) {
				const payload = data.payload;
				setInitialValues({
					conveyorBearingsGreaseOK: payload.conveyorBearingsGrease,
					conveyorBearingsGreaseNOK: !payload.conveyorBearingsGrease,
					conveyorBearingsGreaseComment: payload.conveyorBearingsGreaseComment,
					binBearingsGreaseOK: payload.binBearingsGrease,
					binBearingsGreaseNOK: !payload.binBearingsGrease,
					binBearingsGreaseComment: payload.binBearingsGreaseComment,
					pneumaticMaintenancePurgeOK: payload.pneumaticMaintenancePurge,
					pneumaticMaintenancePurgeNOK: !payload.pneumaticMaintenancePurge,
					pneumaticMaintenancePurgeComment:
						payload.pneumaticMaintenancePurgeComment,
					electrovalvesCleaningOK: payload.electrovalvesCleaning,
					electrovalvesCleaningNOK: !payload.electrovalvesCleaning,
					electrovalvesCleaningComment: payload.electrovalvesCleaningComment,
					pneumaticPistonsRodCleaningOK: payload.pneumaticPistonsRodCleaning,
					pneumaticPistonsRodCleaningNOK: !payload.pneumaticPistonsRodCleaning,
					pneumaticPistonsRodCleaningComment:
						payload.pneumaticPistonsRodCleaningComment,
					airFiltersCleaningOK: payload.airFiltersCleaning,
					airFiltersCleaningNOK: !payload.airFiltersCleaning,
					airFiltersCleaningComment: payload.airFiltersCleaningComment,
					loadingChuteCleaningOK: payload.loadingChuteCleaning,
					loadingChuteCleaningNOK: !payload.loadingChuteCleaning,
					loadingChuteCleaningComment: payload.loadingChuteCleaningComment,
					binVibratorsOK: payload.binVibrators,
					binVibratorsNOK: !payload.binVibrators,
					binVibratorsComment: payload.binVibratorsComment,
					binGatesAlignmentOK: payload.binGatesAlignment,
					binGatesAlignmentNOK: !payload.binGatesAlignment,
					binGatesAlignmentComment: payload.binGatesAlignmentComment,
					conveyorBeltAlignmentOK: payload.conveyorBeltAlignment,
					conveyorBeltAlignmentNOK: !payload.conveyorBeltAlignment,
					conveyorBeltAlignmentComment: payload.conveyorBeltAlignmentComment,
					beltTensionOK: payload.beltTension,
					beltTensionNOK: !payload.beltTension,
					beltTensionComment: payload.beltTensionComment,
					transmissionPulleysOK: payload.transmissionPulleys,
					transmissionPulleysNOK: !payload.transmissionPulleys,
					transmissionPulleysComment: payload.transmissionPulleysComment,
					dustCollectorOperationOK: payload.dustCollectorOperation,
					dustCollectorOperationNOK: !payload.dustCollectorOperation,
					dustCollectorOperationComment: payload.dustCollectorOperationComment,
					siloFullAlarmOK: payload.siloFullAlarm,
					siloFullAlarmNOK: !payload.siloFullAlarm,
					siloFullAlarmComment: payload.siloFullAlarmComment,
					emergencyStopsOK: payload.emergencyStops,
					emergencyStopsNOK: !payload.emergencyStops,
					emergencyStopsComment: payload.emergencyStopsComment,
					waterPumpOK: payload.waterPump,
					waterPumpNOK: !payload.waterPump,
					waterPumpComment: payload.waterPumpComment,
					admixturePumpOK: payload.admixturePump,
					admixturePumpNOK: !payload.admixturePump,
					admixturePumpComment: payload.admixturePumpComment,
					pneumaticGatesOK: payload.pneumaticGates,
					pneumaticGatesNOK: !payload.pneumaticGates,
					pneumaticGatesComment: payload.pneumaticGatesComment,
					scaleCalibrationCheckOK: payload.scaleCalibrationCheck,
					scaleCalibrationCheckNOK: !payload.scaleCalibrationCheck,
					scaleCalibrationCheckComment: payload.scaleCalibrationCheckComment,
					dustEmissionCheckOK: payload.dustEmissionCheck,
					dustEmissionCheckNOK: !payload.dustEmissionCheck,
					dustEmissionCheckNorth: payload.dustEmissionCheckNorth,
					dustEmissionCheckSouth: payload.dustEmissionCheckSouth,
					dustEmissionCheckEast: payload.dustEmissionCheckEast,
				});
				setLoadingButton(false);
			} else {
				setLoadingButton(false);
				openNotification("error", "Error", data.message);
			}
		} catch (err) {
			setLoadingButton(false);
			openNotification(
				"error",
				"Error",
				"Error while trying to get production",
			);
			console.error(err.message);
			return null;
		}
	};

	const CustomForm = () => {
		return (
			<Form
				form={form}
				layout="vertical"
				style={{ marginTop: "20px" }}
				initialValues={initialValues}
			>
				<Row gutter={16} style={{ paddingBottom: 20, paddingTop: 20 }}>
					<Col span={24}>
						<Row gutter={16} justify={"space-between"}>
							<Col span={8}>
								<Text strong>Description / Additional Description</Text>
							</Col>
							<Col span={8}>
								<Text strong>Comments</Text>
							</Col>
							<Col>
								<Row gutter={16} justify={"end"}>
									<Col>
										<Text strong>OK</Text>
									</Col>
									<Col>
										<Text strong>NOK</Text>
									</Col>
								</Row>
							</Col>
						</Row>
					</Col>
				</Row>
				<Row gutter={16}>
					<ItemChecked
						ok={"conveyorBearingsGreaseOK"}
						nok={"conveyorBearingsGreaseNOK"}
						text={"conveyorBearingsGreaseComment"}
						title="Grease conveyor bearings"
						description="Grease must be applied to the conveyor bearings"
						type="comment"
					/>

					<ItemChecked
						ok={"binBearingsGreaseOK"}
						nok={"binBearingsGreaseNOK"}
						text={"binBearingsGreaseComment"}
						title="Grease bin bearings"
						description="Grease must be applied to the aggregate bin gate bearings"
						type="comment"
					/>

					<ItemChecked
						ok={"pneumaticMaintenancePurgeOK"}
						nok={"pneumaticMaintenancePurgeNOK"}
						text={"pneumaticMaintenancePurgeComment"}
						title="Purge pneumatic system maintenance unit"
						description="Drain water from the maintenance unit of the pneumatic systems"
						type="comment"
					/>

					<ItemChecked
						ok={"electrovalvesCleaningOK"}
						nok={"electrovalvesCleaningNOK"}
						text={"electrovalvesCleaningComment"}
						title="Clean electrovalves"
						description="Perform cleaning of the pneumatic electrovalves"
						type="comment"
					/>

					<ItemChecked
						ok={"pneumaticPistonsRodCleaningOK"}
						nok={"pneumaticPistonsRodCleaningNOK"}
						text={"pneumaticPistonsRodCleaningComment"}
						title="Clean pneumatic piston rods"
						description="Perform cleaning on the pneumatic piston rods"
						type="comment"
					/>

					<ItemChecked
						ok={"airFiltersCleaningOK"}
						nok={"airFiltersCleaningNOK"}
						text={"airFiltersCleaningComment"}
						title="Clean air filters"
						description="Perform cleaning of the compressor air filters"
						type="comment"
					/>

					<ItemChecked
						ok={"loadingChuteCleaningOK"}
						nok={"loadingChuteCleaningNOK"}
						text={"loadingChuteCleaningComment"}
						title="Clean loading chute"
						description="Perform cleaning of the loading chute"
						type="comment"
					/>

					<ItemChecked
						ok={"binVibratorsOK"}
						nok={"binVibratorsNOK"}
						text={"binVibratorsComment"}
						title="Check bin vibrators"
						description="Check that the bin vibrators work properly"
						type="comment"
					/>

					<ItemChecked
						ok={"binGatesAlignmentOK"}
						nok={"binGatesAlignmentNOK"}
						text={"binGatesAlignmentComment"}
						title="Check bin gate alignment"
						description="Check the alignment of the bin gates"
						type="comment"
					/>

					<ItemChecked
						ok={"conveyorBeltAlignmentOK"}
						nok={"conveyorBeltAlignmentNOK"}
						text={"conveyorBeltAlignmentComment"}
						title="Check conveyor belt alignment"
						description="Check the alignment of the conveyor belt"
						type="comment"
					/>

					<ItemChecked
						ok={"beltTensionOK"}
						nok={"beltTensionNOK"}
						text={"beltTensionComment"}
						title="Check belt tension"
						description="Verify that the belt tension is adequate"
						type="comment"
					/>

					<ItemChecked
						ok={"transmissionPulleysOK"}
						nok={"transmissionPulleysNOK"}
						text={"transmissionPulleysComment"}
						title="Check transmission pulleys"
						description="Verify that the transmission pulleys that rotate the belt are in good condition"
						type="comment"
					/>

					<ItemChecked
						ok={"dustCollectorOperationOK"}
						nok={"dustCollectorOperationNOK"}
						text={"dustCollectorOperationComment"}
						title="Check dust collector operation"
						description="Verify that the dust collector works properly"
						type="comment"
					/>

					<ItemChecked
						ok={"siloFullAlarmOK"}
						nok={"siloFullAlarmNOK"}
						text={"siloFullAlarmComment"}
						title="Check silo full alarm"
						description="Verify that the silo full alarm works properly"
						type="comment"
					/>

					<ItemChecked
						ok={"emergencyStopsOK"}
						nok={"emergencyStopsNOK"}
						text={"emergencyStopsComment"}
						title="Check emergency stops"
						description="Verify that emergency stops perform their function"
						type="comment"
					/>

					<ItemChecked
						ok={"waterPumpOK"}
						nok={"waterPumpNOK"}
						text={"waterPumpComment"}
						title="Check water pump"
						description="Verify proper operation of the water pump"
						type="comment"
					/>

					<ItemChecked
						ok={"admixturePumpOK"}
						nok={"admixturePumpNOK"}
						text={"admixturePumpComment"}
						title="Check admixture pump"
						description="Verify proper operation of the admixture pump"
						type="comment"
					/>

					<ItemChecked
						ok={"pneumaticGatesOK"}
						nok={"pneumaticGatesNOK"}
						text={"pneumaticGatesComment"}
						title="Check pneumatic gates"
						description="Verify pneumatic gates of the plant"
						type="comment"
					/>

					<ItemChecked
						ok={"scaleCalibrationCheckOK"}
						nok={"scaleCalibrationCheckNOK"}
						text={"scaleCalibrationCheckComment"}
						title="Check scale calibration with graduated tare weights (CIDC-006)"
						description="Verify that the scales indicate the weight referenced to the graduated tare weights"
						type="comment"
					/>
					<ItemChecked
						ok={"dustEmissionCheckOK"}
						nok={"dustEmissionCheckNOK"}
						text={"dustEmissionCheckNorth"}
						text2={"dustEmissionCheckSouth"}
						text3={"dustEmissionCheckEast"}
						title="Check dust emissions"
						description="Verify dust emissions around the plant perimeter for 30 seconds in 6 minutes"
						type="triple"
					/>
				</Row>
			</Form>
		);
	};

	return (
		<>
			{contextHolder}
			{loadingButton ? <CustomSpinner /> : <CustomForm />}
		</>
	);
};

export default ProductionMonthlyView;

const ItemChecked = ({
	ok,
	nok,
	text,
	text2,
	text3,
	title,
	description,
	type,
}) => {
	return (
		<Col span={24} style={{ paddingTop: type === "triple" ? 16 : 0 }}>
			<Row gutter={16} justify={"space-between"}>
				<Col span={8}>
					<Row>
						<Col span={24}>
							<Text strong>{title}</Text>
						</Col>
						<Col span={24} seco>
							<Text strong type="secondary">
								{description}
							</Text>
						</Col>
					</Row>
				</Col>
				<Col span={8}>
					{type === "comment" && (
						<Form.Item name={text}>
							<Input.TextArea size="large" readOnly />
						</Form.Item>
					)}
					{type === "triple" && (
						<Flex vertical>
							<Form.Item name={text} label="North">
								<Input.TextArea size="large" readOnly />
							</Form.Item>
							<Form.Item name={text2} label="South">
								<Input.TextArea size="large" readOnly />
							</Form.Item>
							<Form.Item name={text3} label="East">
								<Input.TextArea size="large" readOnly />
							</Form.Item>
						</Flex>
					)}
				</Col>
				<Col>
					<Row gutter={16}>
						<Col>
							<Form.Item name={ok} valuePropName="checked">
								<Checkbox style={{ pointerEvents: "none" }}></Checkbox>
							</Form.Item>
						</Col>
						<Col>
							<Form.Item name={nok} valuePropName="checked">
								<Checkbox style={{ pointerEvents: "none" }}></Checkbox>
							</Form.Item>
						</Col>
					</Row>
				</Col>
			</Row>
		</Col>
	);
};
